import { FlexBox } from '@airship-platform/jam-web/components';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { DiscountAndFee } from '../../data-access/products';
import DiscountSummary from './DiscountSummary';

interface DiscountsQueryListProps {
  children: (discount: DiscountAndFee) => React.ReactNode;
  items: DiscountAndFee[];
}

const DiscountsQueryList: React.FC<DiscountsQueryListProps> = ({
  children,
  items,
}) => (
  <FlexBox flexDirection={'column'} gap={0}>
    {items.map((discount) => (
      <Box key={discount.discountsAndFeesId}>
        <FlexBox
          alignItems={'center'}
          userSelect={'none'}
          px={1}
          py={2}
          gap={2}
        >
          <DiscountSummary discount={discount} iconSize={'1.25rem'} />
          {children(discount)}
        </FlexBox>
        <Divider />
      </Box>
    ))}
  </FlexBox>
);

export default DiscountsQueryList;
